import React, { useState, useEffect, Fragment, cloneElement, createContext, forwardRef, useContext, useRef, Children, isValidElement } from 'react';
import PropTypes from 'prop-types';
import {TextField, useMediaQuery, ListSubheader, Checkbox} from '@material-ui/core/';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useTheme} from '@material-ui/core/styles';
import { VariableSizeList } from 'react-window';
import {CheckBoxOutlineBlank, CheckBox} from '@material-ui/icons';
import { useStyles } from "./style";
const LISTBOX_PADDING = 8; // px

function renderRow(props) {
    const { data, index, style } = props;
    return cloneElement(data[index], {
        style: {
            ...style,
            top: style.top + LISTBOX_PADDING,
        },
    });
}

const OuterElementContext = createContext({});

const OuterElementType = forwardRef((props, ref) => {
    const outerProps = useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
}

// Adapter for react-window
const ListboxComponent = forwardRef(function ListboxComponent(props, ref) {
    const { children, ...other } = props;
    const itemData = Children.toArray(children);
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
    const itemCount = itemData.length;
    const itemSize = smUp ? 36 : 48;

    const getChildSize = (child) => {
        if (isValidElement(child) && child.type === ListSubheader) {
            return 48;
        }

        return itemSize;
    };

    const getHeight = () => {
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
    };

    const gridRef = useResetCache(itemCount);

    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={itemData}
                    height={getHeight() + 2 * LISTBOX_PADDING}
                    width="100%"
                    ref={gridRef}
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    itemSize={(index) => getChildSize(itemData[index])}
                    overscanCount={5}
                    itemCount={itemCount}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
});

ListboxComponent.propTypes = {
    children: PropTypes.node,
};

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox style={{ color:'blue' }} fontSize="small" />;

export default function Virtualize(props) {
    const classes = useStyles(),
        [arrayDeDatos, setArrayDeDatos] = useState(props.arrayDeDatos ? props.arrayDeDatos:''),
        fixedOptions = [arrayDeDatos],
        [value, setValue] = useState([]);

    return (
        <Autocomplete
            multiple
            id="virtualize-demo"
            value={value}
            ListboxComponent={ListboxComponent}
            onChange={(event, newValue) => {
                for (let index = 0; index <= newValue.length; index++) {
                    if(newValue[index]?.id === '0' && newValue.length === 22){
                        setValue([]);
                        props.ObtenerUsuariosSeleccionados([])
                        break;
                    }                    
                    if(newValue[index]?.id === '0'){
                        setValue(arrayDeDatos);
                        props.ObtenerUsuariosSeleccionados(arrayDeDatos)
                        break;
                    }
                    if(newValue.length === 22){
                        setValue([]);
                        props.ObtenerUsuariosSeleccionados([])
                        return;
                    }
                    
                    if(newValue[index]?.id !== '0' || newValue.length===0){
                        setValue([
                            ...newValue.filter((option) => fixedOptions.indexOf(option) === -1),
                        ]);
                        props.ObtenerUsuariosSeleccionados(newValue)
                    }
                }
            }}        
            options={arrayDeDatos}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}  
            className={classes.inputColor}
            noOptionsText="No encontrado"
            renderOption={
                (option, { selected }) => (
                    <Fragment>
                        <Checkbox
                            className={classes.checkedColorDefaultBorder}
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={selected}
                        />
                        {option.name}
                    </Fragment>
                )
            }      
            style={{ width: 500 }}
            renderInput={(params) => (
                <TextField {...params} variant="outlined" label={props.label} placeholder={props.placeholder} 
                    error={(value.length === 0) ? true:false} helperText={(value.length === 0) ? props.mensajeError:null}
                />
            )}    
        />
    );
}
